import { render, staticRenderFns } from "./XForm.vue?vue&type=template&id=eeddebba&scoped=true"
import script from "./XForm.vue?vue&type=script&lang=js"
export * from "./XForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeddebba",
  null
  
)

export default component.exports